import { usePlanningTranslation } from '@libs/utils/translations'
import CardInfo from '@spa/scenes/Plannings/components/Card/CardInfo/CardInfo'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import moment from 'moment'
import React from 'react'
import type { FC } from 'react'
import getPlannedBreakDuration from 'snap-redux/modules/shifts/utils/breaks/getPlannedBreakDuration'
import getRealBreakDuration from 'snap-redux/modules/shifts/utils/breaks/getRealBreakDuration'

import isPast from '../utils/isPast'

type Props = {
  shift: ShiftModel
}
const ShiftHours: FC<Props> = ({ shift }) => {
  const { t } = usePlanningTranslation()

  const meta = {
    past: isPast(shift.starts_at)
  }

  const start = moment(!meta.past ? shift.starts_at : shift.real_starts_at)
  const end = moment(!meta.past ? shift.ends_at : shift.real_ends_at)

  const breakduration = !meta.past
    ? getPlannedBreakDuration(shift.shift_breaks)
    : getRealBreakDuration(shift.shift_breaks)

  return (
    <CardInfo.Content>
      {breakduration
        ? t('weekly.card.hoursContentWithBreak', { breakduration, start, end })
        : t('weekly.card.hoursContent', { start, end })}
    </CardInfo.Content>
  )
}

export default ShiftHours
